import React, {Component} from 'react';
import Page from '../../page/page'
// import ScrollBox from '../scroll/scroll';//生产
import ScrollBox from '../../scroll/scrollBox2.0';
import Svg from '../../svg/index'
import Button from '../../button/button'
import {styleObj} from './styles';

Array.prototype.S = String.fromCharCode(2);
Array.prototype.in_array = function (e) {
    let r = new RegExp(this.S + e + this.S);
    return (r.test(this.S + this.join(this.S) + this.S));
};

class TableField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            styles: styleObj,
            tableData: [],
            tableObj: [],
            // shouldUpdate: true,
            bgColor: '',
            textColor: '',
            _bgColor: '',
            _textColor: '',
            as: false,//是否点击升序
            de: false,//是否点击降序

            itemArr: [],
            itemData: [],
            selectAll: false
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            tableData: nextProps.tableData,
            tableObj: nextProps.tableObj
        })
    }

    componentDidMount() {

        for (let i of this.props.tableObj) {
            i.show = false
        }
        this.setState({

            tableData: this.props.tableData,
            tableObj: this.props.tableObj
        })
    }

    // initScroll = () => {
    //     this.setState({ shouldUpdate: false });
    // };
    mouseOver = (index, data) => {

        data[index].show = true
        this.setState({
            tableObj: data
        })
    }
    mouseOut = (index, data) => {

        data[index].show = false
        this.setState({
            tableObj: data
        })
    }
    overColor = () => {
        this.setState({
            bgColor: "#ccc",
            textColor: "white",
        })
    }
    outColor = () => {
        this.setState({
            bgColor: "#f9f9f9",
            textColor: "#888",

        })
    }
    _overColor = () => {
        this.setState({
            _bgColor: "#ccc",
            _textColor: "white"
        })
    }
    _outColor = () => {
        this.setState({
            _bgColor: "#f9f9f9",
            _textColor: "#888",
        })
    }

    setSelectItem = (index, value) => {

        let itemArr = this.state.itemArr
        let itemData = this.state.itemData
        let num = itemArr.indexOf(index)
        // itemArr.push({'index':index,'value':value})
        if (num > -1) {
            itemArr.splice(num, 1)
            itemData.splice(num, 1)
        } else {
            itemArr.push(index)
            itemData.push(value)
        }
        this.setState({
            itemArr,
            itemData
        })

    }
    setSelectItemAll = () => {
        let selectAll = this.state.selectAll
        let itemArr = [];
        let itemData = [];
        if (!selectAll) {
            for (let i = 0; i < this.state.tableData.length; i++) {
                itemArr.push(i)
                itemData.push(this.state.tableData[i])
            }
        }
        this.setState({
            selectAll: !selectAll,
            itemArr,
            itemData
        })
    }
    handleSequence = (type, property, data, index, array) => {
        var sortObj = data.sort((prev, next) => {

            let a = prev[property];
            let b = next[property];
            for (let i of array) {
                i.as = false
                i.de = false
            }
            //升序 ascending

            if (type == "ascending") {

                array[index].as = true
                array[index].de = false
                this.setState({
                    tableObj: array
                })
                return a.toString().localeCompare(b)
            }

            //降序descending
            if (type == "descending") {
                array[index].as = false
                array[index].de = true
                this.setState({
                    tableObj: array
                })
                return b.toString().localeCompare(a)
            }

            // return function (obj1, obj2) {
            //     let a = obj1[property];
            //     let b = obj2[property];
            //     return type == "ascending" ? a.toString().localeCompare(b) :
            //         type == "descending" ? b.toString().localeCompare(a) : 0
            // }
        })
        this.setState({
            tableData: sortObj
        })
    }

    render() {
        const {...props} = this.props, {...state} = this.state;
        let styles = state.styles, tabWidth = 0;
        for (let i = 0; i < state.tableObj.length; i++) {
            tabWidth += parseInt(state.tableObj[i].fieldWidth)
        }
        let itemData = this.state.itemData
        return (
            <div style={Object.assign({}, styles.table, {width: props.width})}>
                <div style={styles.mdAction}>
                    {props.actions.map(item => (
                        <div style={styles.spanBtn}>
                            <Button scenesType="submit" btnText={item.name}
                                    handleBtn={this.props.handleBtn.bind(this, itemData, item.type)}/>
                        </div>
                    ))
                    }
                </div>

                <div style={styles.tableBox}>
                    <ScrollBox
                        // width={props.width ? props.width : '70rem'}
                        maxHeight={props.maxHeight ? props.maxHeight : '25.5rem'}>
                        <div style={styles.tableCont}>
                            <table style={styles.lockingBox}>
                                <thead style={styles.thead}>
                                <tr style={styles.lockTheadTr}>
                                    {this.props.checkBox ? <div onClick={this.setSelectItemAll} style={styles.checkBox}>
                                        {this.state.selectAll ?
                                            <Svg type="CheckboxOn" width="1rem" height="1rem" fill="#4aa5fe"/> :
                                            <Svg type="CheckboxOff" width="1rem" height="1rem" fill="#4aa5fe"/>
                                        }
                                    </div> : null}
                                    {props.tableObj.map((value, index, array) => (
                                            value.isLock ?
                                                <td onMouseOver={value.isSequence ? this.mouseOver.bind(this, index, array) : null}
                                                    onMouseOut={value.isSequence ? this.mouseOut.bind(this, index, array) : null}
                                                    style={{
                                                        cursor: value.isSequence ? "pointer" : null,
                                                        width: value.fieldWidth
                                                    }} key={index}>
                                                    <div style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center"
                                                    }}>
                                                        {value.fieldText}
                                                        {value.isSequence ?
                                                            <div style={styles.sequenceSvg}>
                                                                <Svg type="Up" width="1rem" height="1rem"
                                                                     fill={value.as ? "#4aa5ff" : "#ccc"}/>
                                                                <Svg type="Down" width="1rem" height="1rem"
                                                                     fill={value.de ? "#4aa5ff" : "#ccc"}/>
                                                            </div> :
                                                            null
                                                        }

                                                    </div>

                                                    {/* {value.isSequence ? (value.as ? " ↑" : value.de ? " ↓" : " ↑↓"): null} */}
                                                    {<div style={{
                                                        cursor: "pointer",
                                                        width: value.fieldWidth,
                                                        position: "absolute",
                                                        display: value.show ? "block" : "none",
                                                        background: "#f9f9f9",
                                                        boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)"
                                                    }}>
                                                        <div onMouseOver={this.overColor}
                                                             onMouseOut={this.outColor}
                                                             style={Object.assign({}, styles.sequenceItem, {
                                                                 background: state.bgColor,
                                                                 color: state.textColor
                                                             })}
                                                             onClick={this.handleSequence.bind(this, "ascending", value.fieldName, state.tableData, index, array)}>
                                                            升序 <Svg type="Up" width="1rem" height="1rem" fill="#4aa5ff"/>
                                                        </div>
                                                        <div onMouseOver={this._overColor}
                                                             onMouseOut={this._outColor}
                                                             style={Object.assign({}, styles.sequenceItem, {
                                                                 background: state._bgColor,
                                                                 color: state._textColor
                                                             })}
                                                             onClick={this.handleSequence.bind(this, "descending", value.fieldName, state.tableData, index, array)}>
                                                            降序 <Svg type="Down" width="1rem" height="1rem" fill="#4aa5ff"/>
                                                        </div>
                                                    </div>
                                                    }
                                                </td> : null
                                        )
                                    )}
                                </tr>
                                </thead>
                                <tbody style={styles.locktbody}>
                                {state.tableData.map((value, index) => (
                                    <tr key={index} style={(index + 1) % 2 ? styles.tbodyTr1 : styles.tbodyTr2}>
                                        {this.props.checkBox ?
                                            <div onClick={this.setSelectItem.bind(this, index, value)}
                                                 style={styles.checkBox}>
                                                {this.state.itemArr.includes(index) ?
                                                    <Svg type="CheckboxOn" width="1rem" height="1rem" fill="#4aa5fe"/> :
                                                    <Svg type="CheckboxOff" width="1rem" height="1rem" fill="#4aa5fe"/>
                                                }
                                            </div> : null}

                                        {props.tableObj.map((objname, index) => (
                                            objname.isLock ?
                                                <td title={value[objname.fieldName]} style={{
                                                    width: objname.fieldWidth,
                                                    textOverflow: "ellipsis",
                                                    overflow: "hidden",
                                                    whiteSpace: "nowrap",
                                                    display: "block"
                                                }}
                                                    key={index + 'gfy'}>{value[objname.fieldName]}</td> : null
                                        ))
                                        }
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                            <table style={{width: tabWidth + "rem"}}>
                                <thead style={styles.thead}>

                                <tr style={styles.theadTr}>
                                    {this.props.checkBox ? <div onClick={this.setSelectItemAll} style={styles.checkBox}>
                                        {this.state.selectAll ?
                                            <Svg type="CheckboxOn" width="1rem" height="1rem" fill="#4aa5fe"/> :
                                            <Svg type="CheckboxOff" width="1rem" height="1rem" fill="#4aa5fe"/>
                                        }
                                    </div> : null}
                                    {props.tableObj.map((value, index, array) => (

                                        <td onMouseOver={value.isSequence ? this.mouseOver.bind(this, index, array) : null}
                                            onMouseOut={value.isSequence ? this.mouseOut.bind(this, index, array) : null}
                                            style={{
                                                cursor: value.isSequence ? "pointer" : null,
                                                width: value.fieldWidth,
                                                position: "relative"
                                            }} key={index}>
                                            <div style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center"
                                            }}>
                                                {value.fieldText}
                                                {value.isSequence ?
                                                    <div style={styles.sequenceSvg}>
                                                        <Svg type="Up" width="1rem" height="1rem"
                                                             fill={value.as ? "#4aa5ff" : "#ccc"}/>
                                                        <Svg type="Down" width="1rem" height="1rem"
                                                             fill={value.de ? "#4aa5ff" : "#ccc"}/>
                                                    </div> :
                                                    null
                                                }

                                            </div>
                                            {<div style={{
                                                cursor: "pointer",
                                                width: value.fieldWidth,
                                                position: "absolute",
                                                display: value.show ? "block" : "none",
                                                background: "#f9f9f9",
                                                boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)"
                                            }}>
                                                <div
                                                    onMouseOver={this.overColor}
                                                    onMouseOut={this.outColor}
                                                    style={Object.assign({}, styles.sequenceItem, {
                                                        background: state.bgColor,
                                                        color: state.textColor
                                                    })}
                                                    onClick={this.handleSequence.bind(this, "ascending", value.fieldName, state.tableData, index, array)}>
                                                    升序 <Svg type="Up" width="1rem" height="1rem" fill="#4aa5ff"/></div>
                                                <div
                                                    onMouseOver={this._overColor}
                                                    onMouseOut={this._outColor}
                                                    style={Object.assign({}, styles.sequenceItem, {
                                                        background: state._bgColor,
                                                        color: state._textColor
                                                    })}
                                                    onClick={this.handleSequence.bind(this, "descending", value.fieldName, state.tableData, index, array)}>
                                                    降序 <Svg type="Down" width="1rem" height="1rem" fill="#4aa5ff"/>
                                                </div>
                                            </div>
                                            }

                                        </td>


                                    ))}
                                </tr>
                                </thead>
                                <tbody style={styles.tbody}>
                                {state.tableData.length ?
                                    state.tableData.map((value, index) => (
                                        <tr key={index} style={(index + 1) % 2 ? styles.tbodyTr1 : styles.tbodyTr2}>
                                            {this.props.checkBox ?
                                                <div
                                                     style={styles.checkBox}>
                                                    {this.state.itemArr.includes(index) ?
                                                        <Svg type="CheckboxOn" width="1rem" height="1rem" fill="#4aa5fe"/> :
                                                        <Svg type="CheckboxOff" width="1rem" height="1rem" fill="#4aa5fe"/>
                                                    }
                                                </div> : null}

                                            {props.tableObj.map((objname, index) => {
                                                {
                                                    this.props.checkBox ?
                                                        <div onClick={this.setSelectItem.bind(this, index, value)}
                                                             style={styles.checkBox}>
                                                            {this.state.itemArr.includes(index) ?
                                                                <Svg type="CheckboxOn" width="1rem" height="1rem"
                                                                     fill="#4aa5fe"/> :
                                                                <Svg type="CheckboxOff" width="1rem" height="1rem"
                                                                     fill="#4aa5fe"/>
                                                            }
                                                        </div> : null
                                                }
                                                let dom = [];
                                                if (index == props.tableObj.length - 1 && objname.fieldName == "operating") {
                                                    dom.push(<td title={value[objname.fieldName]} key={index + 'gfy'}
                                                                 style={{
                                                                     width: objname.fieldWidth,
                                                                     textOverflow: "ellipsis",
                                                                     overflow: "hidden",
                                                                     whiteSpace: "nowrap",
                                                                     display: "block"
                                                                 }}
                                                                 onClick={props.operatingFn ? props.operatingFn.bind(this, value) : () => null}
                                                    >
                                                        <div>查看</div>
                                                    </td>);
                                                } else {
                                                    dom.push(<td title={value[objname.fieldName]} key={index + 'gfy'}
                                                                 style={{
                                                                     width: objname.fieldWidth,
                                                                     textOverflow: "ellipsis",
                                                                     overflow: "hidden",
                                                                     whiteSpace: "nowrap",
                                                                     display: "block"
                                                                 }}>
                                                        {value[objname.fieldName]}
                                                    </td>);
                                                }
                                                return dom;
                                            })}
                                        </tr>)) :
                                    <tr style={styles.emptyBox}>
                                        <td style={styles.loadBox}>
                                            {this.props.loading ?
                                                <div style={styles.loading}>
                                                    正在拼命加载数据中
                                                    {/*<Loading tip={true} tipText={"正在拼命加载数据中..."} />*/}
                                                </div> :
                                                <label style={styles.emptyText}>没有找到匹配的数据</label>
                                            }
                                        </td>
                                    </tr>
                                }
                                </tbody>
                            </table>
                        </div>
                    </ScrollBox>
                    {props.hidePage ? null :
                        <div style={Object.assign({}, styles.pageBox, {width: props.width})}>
                            <Page handlePage={props.handlePage}
                                  totalNum={props.totalNum}
                                  pageNumber={props.pageNumber}
                                  pageSize={props.pageSize || 10}
                                  showPageSize={false}
                            />
                        </div>

                    }

                </div>

            </div>
        )
    }
}
export default TableField;
